<script>
import Layout from '@layouts/main.vue';
import MessageBubble from '@components/messages/message-bubble.vue';
import UseLargeScreen from '@components/use-large-screen.vue';
import Sidebar from '@components/sidebar/sidebar.vue';
import { helperMixin } from '@mixins/helper-mixin';
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';
import {
  authMethods,
  authComputed,
  clientComputed,
  clientMethods,
} from '@state/helpers';
import _ from 'lodash';
import {
  ChatData,
  connectToChannel,
  getStreatmClient,
} from '@state/chatService';
import moment from 'moment';
export default {
  page: {
    title: 'Messages',
    meta: [{ name: 'description', content: 'The Messages page.' }],
  },
  components: {
    Layout,
    MessageBubble,
    Sidebar,
    UseLargeScreen,
  },
  mixins: [helperMixin, breakpointsMixin],
  data() {
    return {
      activeChannel: {},
      activeClient: {},
      activeClientState: {},
      messages: [],
      newMessage: '',
      isLoadingChannel: false,
      allChatClientClone: [],
      newChatDataStream: [],
      errorFetchingChatData: false,
      errorFetchingClientChat: false,
    };
  },
  destroyed() {
    this.$_clearSelections();
  },
  async mounted() {
    this.isLoadingChannel = true;
    if (this.trainerId && this.allClient.length === 0) {
      await this.getAllClient({ trainerId: this.trainerId });
    }
    this.newChatDataStream = await ChatData.init();
    if (this.registeredClient && this.registeredClient.length > 0) {
      await this.initializeStreamChannel(this.registeredClient[0]);
    }
    const streamClient = await getStreatmClient();
    streamClient.on((event) => {
      if (
        event.type === 'notification.message_new' ||
        event.type === 'message.new'
      ) {
        const channelUserID = event.channel_id.split('_');
        const channelIndex = this.newChatDataStream.findIndex(
          (client) => client.clientId === channelUserID[1]
        );
        if (channelIndex !== -1) {
          this.newChatDataStream[channelIndex].latestMessage = event.message;
          this.newChatDataStream[channelIndex].unreadMessages =
            this.newChatDataStream[channelIndex].unreadMessages + 1;
        }
      }
    });
    this.isLoadingChannel = false;
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    _() {
      return _;
    },
    newChatData() {
      const chatDataStream = this.newChatDataStream
        ?.slice()
        .sort(function(a, b) {
          if (b.unreadMessages < a.unreadMessages) {
            return -1;
          } else if (
            b.latestMessage &&
            a.latestMessage &&
            new Date(b.latestMessage.created_at) <
              new Date(a.latestMessage.created_at)
          ) {
            return -1;
          } else if (
            b.latestMessage &&
            a.latestMessage &&
            new Date(b.latestMessage.created_at) >
              new Date(a.latestMessage.created_at)
          ) {
            return 1;
          } else if (b.unreadMessages > a.unreadMessages) {
            return 1;
          } else if (a.latestMessage) {
            return -1;
          }
          return 0;
        });
      return chatDataStream;
    },
    registeredClient() {
      return this.newChatDataStream?.filter((client) => {
        return (
          (client.profile && client.profile.lastSeen) ||
          (client.profile && client.profile.last_seen) ||
          (_.has(client.profile, 'successfulSignup') &&
            client.profile.successfulSignup)
        );
      });
    },
    currentUserAvatar() {
      return (
        this.currentUser &&
        this.currentUser.trainer &&
        this.currentUser.trainer.mediaAssets.avatarImage.url
      );
    },
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    clientAvatar(client) {
      return client &&
        client.profile &&
        client.profile.mediaAssets &&
        client.profile.mediaAssets.avatarImage &&
        client.profile.mediaAssets.avatarImage.url
        ? client.profile.mediaAssets.avatarImage.url
        : require('@assets/images/placeholder-avatar.png');
    },
    async initializeStreamChannel(client) {
      // Start loading
      this.isLoadingChannel = true;
      this.errorFetchingChatData = false;
      this.errorFetchingClientChat = false;
      this.activeClient = client;
      this.messages = [];
      try {
        // Remove new message listener before switching to the new channel
        if (!_.isEmpty(this.activeChannel)) {
          await this.activeChannel.stopWatching();
          await this.activeChannel.off('message.new', this.addMessage);
        }

        const { channelMessages, channel, error } = await connectToChannel(
          client,
          this.newChatData
        );
        this.activeChannel = channel;
        this.messages = channelMessages;

        this.activeClientState =
          channel.state &&
          channel.state.members &&
          channel.state.members[this.activeClient._id] &&
          channel.state.members[this.activeClient._id].user;

        if (!_.isEmpty(this.activeChannel) && !error) {
          this.errorFetchingClientChat = false;
          await this.activeChannel.on('message.new', this.addMessage);
          // Update latestMessage in chanenels list item
          const i = this.newChatDataStream.findIndex(
            (client) => client._id === this.activeClient._id
          );
          if (this.messages && this.messages.length > 0) {
            this.newChatDataStream[i].unreadMessages = 0;
          }
          this.scrollToBottom('init');
        } else {
          this.activeChannel = {};
          this.errorFetchingClientChat = true;
        }
      } catch (e) {
        this.activeChannel = {};
        this.errorFetchingClientChat = true;
        console.log('Faild to fetch chat data');
      }

      // Done loading
      this.isLoadingChannel = false;
    },
    isRegistered(client) {
      return (
        (client.profile && client.profile.lastSeen) ||
        (client.profile && client.profile.last_seen) ||
        (_.has(client.profile, 'successfulSignup') &&
          client.profile.successfulSignup)
      );
    },
    dateFormat(date) {
      return moment(date).format('MMM DD [at] hh:mm a');
    },
    scrollToBottom(val) {
      const child = document.getElementsByClassName('messages-wrapper')[0];
      const parent = document.getElementsByClassName(
        'client-messages-container'
      )[0];
      if (val === 'init' && child) {
        child.scrollTop = child.scrollHeight;
      } else {
        if (child && parent) {
          child.scroll({
            top: child.scrollHeight,
            behavior: 'smooth',
          });
        }
      }
    },
    async addMessage(event) {
      this.messages.push(event.message);
      if (this.$route.name === 'messages') {
        // // Update latestMessage in chanenels list item
        const i = this.newChatDataStream.findIndex(
          (client) => client._id === this.activeClient._id
        );
        if (this.messages && this.messages.length > 0) {
          this.newChatDataStream[i].latestMessage = event.message;
        }
        // Read all messages state update
        await this.activeChannel.markRead();
        this.scrollToBottom();
      }
    },
    async sendMessage(e) {
      // Prevent sending empty messages and trim extra spaces
      if (this.newMessage.trim() !== '') {
        await this.activeChannel.sendMessage({ text: this.newMessage.trim() });
        this.newMessage = '';
      } else {
        this.newMessage = '';
        e.target.value = '';
      }
    },
    async handleClick(item) {
      await this.initializeStreamChannel(item);
    },
    async toClients() {
      await this.$router.push({ name: 'clients' }).catch(() => {});
    },
  },
};
</script>

<template>
  <UseLargeScreen v-if="isSmallScreenView" />
  <Layout v-else>
    <div class="container-wrapper">
      <Sidebar style="padding-left: 0; padding-right: 0; width: 39rem;">
        <h5 class="sidebar-section-title" style="margin-left: 3rem;"
          >All Messages</h5
        >
        <ul class="list-messages">
          <template v-for="client in newChatData">
            <li
              v-if="isRegistered(client)"
              :class="[
                'list-messages-item',
                { new: client.new },
                { unread: client.unreadMessages > 0 },
                {
                  active:
                    activeClient &&
                    client &&
                    (client._id === activeClient._id ||
                      client.clientId === activeClient.clientId),
                },
              ]"
              :key="client._id"
              @click="handleClick(client)"
              tabindex="0"
              ><span
                v-if="client.unreadMessages > 0"
                class="new-message-bubble"
              />
              <div class="row">
                <div class="col-2">
                  <div class="list-messages-item-avatar">
                    <img :src="clientAvatar(client)" />
                  </div>
                </div>
                <div class="col-9">
                  <div class="list-messages-item-meta">
                    <h5 class="list-messages-item-title ellipsis">{{
                      client.profile.firstName + ' ' + client.profile.lastName
                    }}</h5>
                    <p class="list-messages-item-text ellipsis">{{
                      client.latestMessage && client.latestMessage.text
                        ? client.latestMessage.text
                        : ''
                    }}</p>
                  </div>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </Sidebar>

      <div v-if="!errorFetchingChatData" class="content-wrapper no-pad">
        <div
          class="client-details-wrapper d-flex p-3"
          v-if="!_.isEmpty(activeChannel)"
        >
          <div class="client-details-avatar"
            ><img :src="clientAvatar(activeClient)"
          /></div>
          <div class="client-meta pl-3">
            <h5>{{
              activeClient.profile.firstName +
                ' ' +
                activeClient.profile.lastName
            }}</h5>
            <span class="m-0"
              >Last active at :
              {{ dateFormat(activeClientState.last_active) }}</span
            >
          </div>
          <div class="flex-grow-1 text-right">
            <router-link
              :to="{
                name: 'clientProgram',
                params: { id: activeClient._id, client: activeClient },
              }"
              >View Profile</router-link
            >
          </div>
        </div>
        <div class="client-messages-container">
          <div
            v-if="messages.length > 0 && !errorFetchingClientChat"
            class="messages-wrapper"
          >
            <div v-for="message in messages" :key="message.id">
              <MessageBubble
                :image="
                  message.user.id === trainerId
                    ? currentUserAvatar
                    : activeClient.profile &&
                      activeClient.profile.mediaAssets &&
                      activeClient.profile.mediaAssets.avatarImage
                    ? activeClient.profile.mediaAssets.avatarImage.url
                    : ''
                "
                :content="message"
                :class="[
                  { trainer: message.user.id === trainerId },
                  { isMe: message.user.id === trainerId },
                ]"
              />
            </div>
          </div>
          <div v-else>
            <p
              class="loading-channel"
              v-if="messages.length === 0 && isLoadingChannel"
              >Loading...<BaseIcon name="sync" spin class="icon"
            /></p>
          </div>
          <div
            class="empty-state-container"
            v-if="newChatData.length === 0 && !isLoadingChannel"
          >
            <h2>No client found for your account.</h2>
            <p>Create your first client and start conversion.</p>
            <div class="actions">
              <BaseButton
                type="button"
                class="btn-primary btn-round"
                @click="toClients"
              >
                Create New Client
              </BaseButton>
            </div>
          </div>
          <div
            v-if="
              !_.isEmpty(activeClient) &&
                isRegistered(activeClient) &&
                !_.isEmpty(activeChannel) &&
                messages.length === 0 &&
                !errorFetchingClientChat &&
                !isLoadingChannel
            "
            class="empty-chat"
          >
            This is the beginning of your chat history with
            {{ activeClient.profile.firstName }}. Say hello!
          </div>
          <div
            v-if="
              !_.isEmpty(activeClient) &&
                isRegistered(activeClient) &&
                errorFetchingClientChat &&
                !isLoadingChannel
            "
            class="empty-chat not-init"
          >
            Error fetching {{ activeClient.profile.firstName }}'s chat data.
          </div>
        </div>

        <div
          class="message-input-wrapper"
          v-if="!_.isEmpty(activeChannel) && !errorFetchingClientChat"
        >
          <BaseInputTextarea
            @keydown.enter="sendMessage($event)"
            v-model="newMessage"
            name="mesasge"
            rows="4"
            max-rows="8"
            placeholder="Start typing. Hit enter to post..."
          />
        </div>
      </div>
      <div class="empty-message--large" v-if="errorFetchingChatData">
        <h1
          >Error fetching clients chat data, refresh the page or try using
          different browser.</h1
        >
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';
// Unscoped GLOBAL styles needed because the child style loses the scope...
// stylelint-disable selector-pseudo-element-no-unknown

.empty-message--large {
  h1 {
    margin-top: 10rem;
  }
}

.empty-chat {
  align-items: center;
  background-color: $color-off-white;
  background-color: $color-primary-alt;
  border-radius: 8px;
  color: white;
  display: flex;
  font-weight: 600;
  justify-content: center;
  left: 25%;
  letter-spacing: 0.116667px;
  margin-bottom: 1rem;
  padding: 2rem;
  position: absolute;
  right: 25%;
  text-align: center;
  top: 60%;
  width: 50%;
  @include calc-font-size(0.8);

  &.not-init {
    top: 50%;
    @include calc-font-size(1.2);
  }
}

.loading-channel {
  align-self: center;
  margin-left: 2%;
  margin-top: 2%;
}
.input-textarea {
  background-color: white;
  border-top: 1px solid rgba($color-gray-wo-rgb, 0.5);
  height: 100%;
  margin: 0;
}
</style>

<style lang="scss" scoped>
@import '@design';
.content-wrapper {
  position: relative;
}
.client-details-wrapper {
  background: rgb(245 245 239);
  position: absolute;
  width: 100%;
  z-index: 1;
  .client-details-avatar {
    img {
      border-radius: 0.6rem;
      height: 48px;
      -o-object-fit: cover;
      object-fit: cover;
      width: 48px;
    }
  }
}
.list-messages {
  .list-messages-item {
    border-bottom: 1px solid $color-light-gray;
    display: flex;
    padding: 0 1.6rem 1.5rem 3.4rem;
    padding-top: 1.5rem;

    &.unread {
      padding-left: 0;
    }
    .row {
      width: 100%;
    }

    .new-message-bubble {
      background-color: $color-action;
      border-radius: 50%;
      height: 10px;
      margin-left: 1.1rem;
      margin-right: 1.2rem;
      margin-top: 1.2rem;
      min-width: 10px;
      position: relative;
      width: 10px;
    }

    &:hover {
      background-color: $color-light-gray;
      cursor: pointer;
    }

    &:focus,
    &.active {
      background-color: $color-light-gray;
      outline: none;

      .notification-bubble {
        border-color: $color-light-gray;
      }
    }

    &.new {
      position: relative;

      .notification-bubble {
        height: 1.2rem;
        justify-self: center;
        left: 1rem;
        top: 2.8rem;
        width: 1.2rem;
      }

      &:hover .notification-bubble {
        border-color: $color-light-gray;
      }

      &:first-child .notification-bubble {
        top: 1.3rem;
      }
    }

    .list-messages-item-avatar {
      height: 3.4rem;
      margin-top: 0.2rem;
      width: 3.4rem;

      img {
        border-radius: $base-border-radius-sm;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }

    .list-messages-item-meta {
      .list-messages-item-title {
        line-height: 2.2rem;
        margin-bottom: 0;
      }

      .list-messages-item-text {
        font-size: 1.2rem;
        letter-spacing: 0.3px;
        line-height: 1.8rem;
        margin-bottom: 0;
      }
    }
  }
}

.client-messages-container {
  height: calc(100% - 12rem);
  position: relative;
  top: 68px;
  .messages-wrapper {
    height: calc(100% - 68px);
    overflow-y: scroll;
    padding: 3rem 3rem 0;
  }
}
.message-input-wrapper {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 1;
}
::v-deep .isMe {
  .avatar {
    margin-left: 0 !important;
  }
}

.empty-state-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  margin-bottom: 30vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15vh;
  padding: 6rem;
  text-align: center;
  width: 50%;

  p {
    margin-top: 2rem;
  }

  .actions {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 2rem;

    ::v-deep .button {
      height: 3.7rem;
      padding-bottom: 0.2rem;
      padding-top: 0.2rem;
      white-space: nowrap;
    }

    ::v-deep .button.btn-secondary {
      margin-right: 10px;
    }
  }
}
</style>
